import { Injectable, OnInit } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '@env';
import { Router } from '@angular/router';
import { TrackingService } from '@modules/client/services/tracking.service';
import { ApplymentModel } from '@app/services/client-general-settings/applyment/applyment.model';
import { MatDialog } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class ClientMainBarService {

  configUrl = 'assets/config.json';

  public headerHideControl = new Subject<any>();

  public isInThePortal = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private trackingService: TrackingService,
    public applymentModel: ApplymentModel,
    private dialog: MatDialog,
  ) { }

  getHeaderHideState(): Observable<any> {
    return this.headerHideControl.asObservable();
  }

  setHeaderHideState(value: any) {
    this.headerHideControl.next(value);
  }

  clearSession(usedLogOffButton = false, autoLogin = false) {
    this.trackingService.loadTrackingScriptToClearSession();
    this.clearSessionBackend().subscribe();
    const token = localStorage.getItem('token');
    localStorage.removeItem(`session_id_tracking_${token}`);
    localStorage.removeItem(`hostClient_tracking_${token}`);
    localStorage.removeItem(`substitute_id_tracking_${token}`);
    localStorage.removeItem(`contact_crm_id_tracking_${token}`);
    localStorage.removeItem(`crm_domain_${token}`);
    localStorage.removeItem(`last_place_id`);
    localStorage.removeItem(`last_place_type_id`);
    localStorage.removeItem(`token`);
    if (!autoLogin) {
      setTimeout(() => {
        if (this.applymentModel.getSettings().log_off_link && usedLogOffButton) {
          window.open(this.applymentModel.getSettings().log_off_link, '_top');
        } else {
          this.router.navigate([this.applymentModel.getSettings().domainParams]);
        }
        // location.reload();
      }, 1000);
    }
    return false;
  }

  clearSessionBackend() {
    return this.http.post(`${environment.API}/applyment/clear-session`, {
      token: localStorage.getItem('token')
    });
  }

  checkLogin()  {
    return this.http.post(`${environment.API}/applyment/check-login`, {
      token: localStorage.getItem('token')
    });
  }
}
